module.exports = __webpack_public_path__ + "static/img/index-nav-3.146102c6.png";